import ReportEdit from './ReportEdit'

export default ReportEdit



// WEBPACK FOOTER //
// ./src/views/ReportEdit/index.js